<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      :vertical="vertical"
      timeout="-1"
      outlined
    >
      {{ text.app.cookieInfo }}

      <template v-slot:action="{ attrs }">
        <v-row justify="space-between" v-bind="attrs">
          <v-col>
            <v-btn
              color="primary"
              text
              x-small
              @click="snackbar = false"
            >
              {{text.buttons.close}}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              text
              x-small
              @click="closeAndRemember"
            >
              {{text.buttons.closeAndRemember}}
            </v-btn>
          </v-col>
        </v-row>

      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { translations } from '@/lang/translations';

export default {
  name: 'CookiesInfo',
  data: () => ({
    vertical: true,
    snackbar: true,
  }),
  mounted() {
    this.checkIfCookiesExists();
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
  },
  methods: {
    closeAndRemember() {
      localStorage.setItem('cookiesInfo', true);
      this.snackbar = false;
    },
    checkIfCookiesExists() {
      if (localStorage.getItem('cookiesInfo') === null) {
        this.snackbar = true;
      } else {
        this.snackbar = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
